module.exports = __webpack_public_path__ + "static/media/GooglePlay@3x.5074b370.png";